import { useMemo } from 'react';
import { getFeatureState } from './selectors';
import { useEditorState } from './VideoEditorStateContext';

export default function useFeature(path: Array<string | number>) {
  const { features } = useEditorState();
  return useMemo(() => {
    return getFeatureState(features, path);
  }, [features, path]);
}
